import { createApi } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const importProductDeclaration = createApi({
  reducerPath: "importProductDeclaration",
  baseQuery,
  tagTypes: ["ImportProductDeclaration"],
  endpoints: (builder) => ({
    getImportProductDeclaration: builder.query({
      query: ({ id,params }) => ({
        url: `/import/invoice/Declaration/${id}`,
        method: "GET",  
      }),
      transformResponse: (response) =>{
        const data = response?.data
         const normalized = Array.isArray(data) ? data : [data];
        return normalized.map((item,idx) => ({
          ...item,
          srNo: idx + 1,
          id: item.declarationId,
          declarationCode : item.declarationTitle
        })); 
        },
      providesTags: ["ImportProductDeclaration"],
    }),
      createImportProductDeclaration: builder.mutation({
      query: ({ id, data }) => ({   
        url: `/import/invoice/Declaration/${id}`,
        method: "PUT",
        body: { declaration: data },
      }),
      invalidatesTags: ["ImportProductDeclaration"],
    }),
      updateImportProductDeclaration: builder.mutation({
      query: ({ id, subId,data }) => ({
        url: `/import/invoice/Declaration/${id}/${subId}`,
        method: "PUT",
        body: { declaration: data },
      }),
      invalidatesTags: ["ImportProductDeclaration"],
    }),
    deleteImportProductDeclaration: builder.mutation({
      query: ({ id }) => {
        return {
          url: `/import/inovice/Declaration/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["ImportProductDeclaration"],
    })
  }),
});
export const {
  useLazyGetImportProductDeclarationQuery,
  useCreateImportProductDeclarationMutation,
  useUpdateImportProductDeclarationMutation,
  useDeleteImportProductDeclarationMutation
} = importProductDeclaration;
